const NoFamily = Vue.component('inventorinfos', {
    template: `
        <div>
            ERROR NO FAMILY SPECIFIED 
        </div>
    `,

    data: function() {
        return {
        };
    },

    mounted() {
        this.$store.commit('hideLoading');

    },

    methods: {

    }
});
